import React from 'react';
import { createBrowserRouter, type RouteObject } from 'react-router-dom';
import IframeLayout from './pages/Iframe/index';
import StandaloneLayout from './pages/Standalone';
import IframeLanding from './pages/Iframe/Landing';
import WithConfig from './components/WithConfig';
import AppPage from './pages/common/AppPage';
import StandaloneLanding from './pages/Standalone/Landing';

const commonRoutes: Array<RouteObject> = [
  {
    path: 'apps/:slug',
    element: <AppPage />,
  },
];

const router = createBrowserRouter([
  {
    element: <WithConfig />,
    path: '/-',
    children: [
      {
        path: '',
        children: [
          {
            path: ':accountId',
            children: [
              {
                path: 'iframe',
                element: <IframeLayout />,
                children: [
                  {
                    path: '',
                    element: <IframeLanding />,
                  },
                  ...commonRoutes,
                  {
                    path: '*',
                    element: <IframeLanding />,
                  },
                ],
              },
              {
                path: 's',
                element: <StandaloneLayout />,
                children: [
                  {
                    path: '',
                    element: <StandaloneLanding />,
                  },
                  ...commonRoutes,
                  {
                    path: '*',
                    element: <StandaloneLanding />,
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
]);

export default router;
